import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { WebStat } from "@miro-site/stats";
var eventHub;
var getEventHub = function() {
    // skip server side imports
    if ("object" === "undefined") {
        return null;
    }
    if (!eventHub) {
        var params = {
            apiHost: "".concat(process.env.NEXT_PUBLIC_ANALYTICS_EVENTHUB_ENDPOINT, "/v1"),
            apiKey: process.env.NEXT_PUBLIC_ANALYTICS_EVENTHUB_AUTH || ""
        };
        var handler = WebStat.createStatHandler({
            apiHost: params.apiHost,
            library: "miro-site/analytics",
            version: "0.0.1",
            addCommonStatParams: function(params) {
                return _object_spread({}, params);
            },
            // eslint-disable-next-line no-console
            sendError: function(err, extra) {
                return console.error(err, extra);
            }
        });
        var methods = {
            identify: function(id) {
                WebStat.identify(handler, params.apiKey, {
                    id: id,
                    name: "",
                    email: ""
                });
            },
            page: function() {
                WebStat.page(handler, params.apiKey);
            },
            track: function(eventName, properties) {
                var cleanProps = {};
                // "properties" can be passed as a string
                if (typeof properties === "string") {
                    var trimmedStringProp = properties.trim();
                    if (trimmedStringProp.length > 0) {
                        cleanProps = {
                            trimmedStringProp: trimmedStringProp
                        };
                    }
                } else if (typeof properties === "object") {
                    cleanProps = properties;
                }
                WebStat.track(handler, params.apiKey, eventName, cleanProps);
            }
        };
        if (!window["analytics"]) {
            window["analytics"] = methods;
        }
        eventHub = methods;
    }
    return eventHub;
};
export default getEventHub();
